import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { APP_TYPES } from '../../slices/app-type-slice/app-type-slice-reducer';
import type { AppTypes } from '../../slices/app-type-slice/app-type-slice-reducer';
import { appTypeSlicePrivateActions } from '../../slices/app-type-slice/app-type-slice-reducer/app-type-slice-reducer';

interface AppTypeProviderChildrenProps {
  children: React.ReactNode;
}

interface AppTypeProviderProps extends AppTypeProviderChildrenProps {
  type: AppTypes;
}

const AppTypeProvider = ({ children, type }: AppTypeProviderProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(appTypeSlicePrivateActions.setAppType(type));
    // We only need to set this once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children;
};

export default {
  /**
   * @warning 🛑 STOP!!! THIS IS MEANT TO BE USED ONCE AT THE ROOT LEVEL OF THE APP
   * @description
   * Provider used to set the app type to `ADMIN`.
   * @example
   * ```ts
   * <AppTypeProvider.Admin>
   *   <YourAppComponent />
   * </AppTypeProvider.Admin>
   * ```
   */
  Admin: ({ children }: AppTypeProviderChildrenProps) => (
    <AppTypeProvider type={APP_TYPES.ADMIN}>{children}</AppTypeProvider>
  ),
  /**
   * @warning 🛑 STOP!!! THIS IS MEANT TO BE USED ONCE AT THE ROOT LEVEL OF THE APP
   * @description
   * Provider used to set the app type to `CLIENT`.
   * @example
   * ```ts
   * <AppTypeProvider.Client>
   *   <YourAppComponent />
   * </AppTypeProvider.Client>
   * ```
   */
  Client: ({ children }: AppTypeProviderChildrenProps) => (
    <AppTypeProvider type={APP_TYPES.CLIENT}>{children}</AppTypeProvider>
  ),
  /**
   * @warning 🛑 STOP!!! THIS IS MEANT TO BE USED ONCE AT THE ROOT LEVEL OF THE APP
   * @description
   * Provider used to set the app type to `HIGHLIGHTER`.
   * @example
   * ```ts
   * <AppTypeProvider.Highlighter>
   *   <YourAppComponent />
   * </AppTypeProvider.Highlighter>
   * ```
   */
  Highlighter: ({ children }: AppTypeProviderChildrenProps) => (
    <AppTypeProvider type={APP_TYPES.HIGHLIGHTER}>{children}</AppTypeProvider>
  ),
};
